import { useEffect, useState } from "react";
import { Copy, FileDown, FileText } from "lucide-react";
import { toast } from "sonner";
import { api, money } from "../../lib/api";

const save = async (tid, fmt, did) => {
  const r = await api.get(`/manual/templates/${tid}/download`, { params: { fmt, dispute_id: did }, responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = `aegis-${tid}${did ? `-${did}` : ""}.${fmt}`;
  a.click();
  URL.revokeObjectURL(a.href);
};

const Card = ({ t, did }) => {
  const copy = () => navigator.clipboard.writeText(t.text).then(() => toast.success("Copied to clipboard"));
  const btn = "flex items-center gap-1.5 px-3 py-2 border border-white/15 font-mono text-[10px] tracking-wider hover:border-brand hover:text-brand transition-colors";
  return (
    <div className="panel p-5" data-testid={`template-${t.id}`}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="max-w-xl"><p className="font-bold flex items-center gap-2"><FileText className="w-4 h-4 text-brand" />{t.title}</p><p className="text-xs text-white/55 mt-1">{t.when}</p></div>
        <div className="flex gap-2">
          <button onClick={copy} className={btn} data-testid={`template-copy-${t.id}`}><Copy className="w-3.5 h-3.5" /> COPY</button>
          <button onClick={() => save(t.id, "pdf", did).catch(() => toast.error("Download failed"))} className={btn} data-testid={`template-pdf-${t.id}`}><FileDown className="w-3.5 h-3.5" /> PDF</button>
          <button onClick={() => save(t.id, "docx", did).catch(() => toast.error("Download failed"))} className={btn} data-testid={`template-docx-${t.id}`}><FileDown className="w-3.5 h-3.5" /> WORD</button>
        </div>
      </div>
      <pre className="mt-4 max-h-72 overflow-auto whitespace-pre-wrap text-[12.5px] leading-relaxed text-white/75 bg-field border border-line p-4 font-sans" data-testid={`template-text-${t.id}`}>{t.text}</pre>
    </div>
  );
};

export const Templates = () => {
  const [disputes, setDisputes] = useState([]);
  const [did, setDid] = useState("");
  const [items, setItems] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get("/disputes").then((r) => setDisputes(Array.isArray(r.data) ? r.data : r.data.disputes || [])).catch(() => setDisputes([])); }, []);
  useEffect(() => { setErr(false); api.get("/manual/templates", { params: { dispute_id: did } }).then((r) => setItems(r.data.templates)).catch(() => setErr(true)); }, [did]);
  return (
    <div data-testid="manual-templates">
      <div className="flex flex-wrap items-center gap-3 mb-5">
        <p className="text-sm text-white/65">Your business name and support email are filled in automatically. Pick a dispute to fill customer, order, amount and reason too:</p>
        <select value={did} onChange={(e) => setDid(e.target.value)} className="bg-field border border-fieldline px-3 py-2 text-sm focus:outline-none focus:border-brand" data-testid="template-dispute-select">
          <option value="">No dispute (blank placeholders)</option>
          {disputes.slice(0, 50).map((d) => <option key={d.id} value={d.id}>{`${d.customer_name} · ${money(d.amount)} · ${d.id}`}</option>)}
        </select>
      </div>
      {err ? <p className="text-sm text-red-400" data-testid="templates-error">Couldn't load templates. Check your connection and reload the page.</p> : !items ? <p className="font-mono text-xs text-white/40">loading templates…</p> : <div className="space-y-5">{items.map((t) => <Card key={t.id} t={t} did={did} />)}</div>}
    </div>
  );
};
